import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let AreaCodePanel = class AreaCodePanel extends Vue {
    constructor() {
        super(...arguments);
        this.rewardTaskList = [];
        this.showTip = false;
        this.keyText = 'order';
    }
    get getSrc() {
        return item => {
            let mapUrl = {
                order: '/icon-order.png',
                turn: '/icon-invi.png',
            };
            return require('../../../assets' + mapUrl[item.type]);
        };
    }
    async created() {
        this.getRewardTaskList();
    }
    async getRewardTaskList() {
        let { data } = await this.$axios.get(`/api/activity/h5Activity/invitation/getRewardTaskList`);
        this.rewardTaskList = (data || []).concat([
            {
                button: '去下单',
                sub: '在常爸APP等自营平台下单返金币',
                title: '下单返金币',
                type: 'order',
            },
            {
                button: '去转换',
                sub: '常爸抖音/视频号直播间或有赞/天猫/小红书店铺订单转换成功得金币',
                title: '订单转换金币',
                type: 'turn',
                url: window.location.origin + '/goods/conversion-coin',
            },
        ]);
    }
    goUrl(item) {
        if (item.type === 'order') {
            if (env.type === 'ivydad') {
                env.commonJump('ivydadreadtool://home/family');
            }
            else {
                window.location.href =
                    window.location.origin + '/center/?pointRefer=tinyUrl';
            }
        }
        else {
            window.location.href = item.url;
        }
    }
    hide() {
        this.close();
    }
    showTipVisible(key) {
        this.keyText = key;
        this.showTip = true;
    }
};
tslib_1.__decorate([
    Prop()
], AreaCodePanel.prototype, "show", void 0);
tslib_1.__decorate([
    Prop()
], AreaCodePanel.prototype, "close", void 0);
AreaCodePanel = tslib_1.__decorate([
    Component({})
], AreaCodePanel);
export default AreaCodePanel;
